module.exports = __webpack_public_path__ + "img/IMG_5002_L_Black_MockedUp.0aa4feef.jpg";